module.exports = __webpack_public_path__ + "img/program-pulih.036919df.png";